import { useEffect, useState } from 'react';

export default function TimeJourneyTable({ timeJourney }) {
  if (!timeJourney) return null;
  const [cleanedTimeJourney, setCleanedTimeJourney] = useState({});

  useEffect(() => {
    if (!timeJourney) return;

    const entries = Object.entries(timeJourney);
    if (entries.length < 2) {
      setCleanedTimeJourney(timeJourney);
      return;
    }

    const lastIndex = entries.length - 1;
    const [lastKey, lastValue] = entries[lastIndex];
    const [secondLastKey, secondLastValue] = entries[lastIndex - 1];

    if (lastKey === 'undefined') {
      const merged = {
        ...secondLastValue,
        correct: (secondLastValue.correct || 0) + (lastValue?.correct || 0),
        incorrect: (secondLastValue.incorrect || 0) + (lastValue?.incorrect || 0),
        overall: (secondLastValue.overall || 0) + (lastValue?.overall || 0),
      };

      const newEntries = [...entries.slice(0, lastIndex - 1), [secondLastKey, merged]];

      setCleanedTimeJourney(Object.fromEntries(newEntries));
    } else {
      setCleanedTimeJourney(timeJourney);
    }
  }, [timeJourney]);

  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm w-full">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-75 text-start align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] leading-snug">Subject</div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[120px] mx-auto leading-snug text-[var(--q3-green-normal)]">
                Correct Attempts
              </div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[120px] mx-auto leading-snug text-[var(--q3-danger-normal)]">
                Incorrect Attempts
              </div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle">
              <div className="line-clamp-2 max-w-[120px] mx-auto leading-snug text-[var(--q3-neutral-light)]">
                Overall
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.entries(cleanedTimeJourney)?.map(([key, value], index) => (
            <tr
              key={key}
              className={`border-b border-[var(--q3-stroke-light)] ${
                index === Object.entries(cleanedTimeJourney).length - 1 ? 'border-b-0' : ''
              } hover:bg-[var(--q3-surface-dim)]`}
            >
              <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
                <div className="text-start px-4">
                  <p className="truncate text-base font-medium text-[var(--q3-neutral-default)]">{key}</p>
                </div>
              </td>
              <td className="border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-light)] text-xs text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">
                  {value.correct} <span className="text-xs">Qs</span>{' '}
                </span>
              </td>
              <td className="border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-light)] text-xs text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">
                  {value.incorrect} <span className="text-xs">Qs</span>{' '}
                </span>
              </td>
              <td className="text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">
                  {value.overall} <span className="text-xs">Qs</span>{' '}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
